import { render } from "./PartnerDashTiles.vue?vue&type=template&id=34b144bc&scoped=true"
import script from "./PartnerDashTiles.vue?vue&type=script&lang=js"
export * from "./PartnerDashTiles.vue?vue&type=script&lang=js"

import "./PartnerDashTiles.vue?vue&type=style&index=0&id=34b144bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b144bc"]])

export default __exports__